import { Outlet } from 'react-router-dom';
import { LayoutDefault } from '../components/layout/default/layoutDefault';
import { LayoutPrevisora } from '../components/layout/previsora/layoutPrevisora';

type Props = {
    viewHeaderAndFooter?: false | boolean;
};

export default function PublicRoute({ viewHeaderAndFooter }: Props) {
    return !viewHeaderAndFooter ? (
        <LayoutDefault>
            <Outlet />
        </LayoutDefault>
    ) : (
        <LayoutPrevisora>
            <Outlet />
        </LayoutPrevisora>
    );
}
